/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnairactualsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Return air actual setpoint" |
*
* @param {Ahu_History_Key_Returnairactualsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnairactualsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Returnairactualsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnairactualsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air actual setpoint")
	return /** @type {LocalizedString} */ ("Consigne réelle air reprise")
});
export { ahu_history_key_returnairactualsetpoint3 as "ahu_history_key_returnAirActualSetpoint" }